/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import cn from "clsx";
import { useSimpliCity } from "cms/hooks/use-simplicity";
import { ReactComponent as PlusIcon } from "cms/assets/icons/plus.svg";
import { ReactComponent as MinusIcon } from "cms/assets/icons/minus.svg";
import { navLinks, myTownshipLink } from "components/header/constants";

const MobileDropdownMenu = (props) => {

    const show = props?.show ?? false;

    const { menu } = useSimpliCity();
    const [openMenu, setOpenMenu] = useState(null);
    const staticLinks = [...navLinks, myTownshipLink];

    const toggleMenuItemDropdown = (title) => {
        if (title === openMenu) {
            setOpenMenu(null);
        } else {
            setOpenMenu(title);
        }
    };

    if (!show) {
        return null;
    }

    return (
        <div className="mobile-dropdown-menu">
            <ul>
                {menu.map((item, index) => {
                    const childMenus = item?.children ?? [];
                    const title = item?.title ?? "";
                    const url = item?.url ?? "";
                    const showMenuItemDropdown = openMenu === title;
                    const level1ItemClassName = cn(
                        "mobile-menu-item-level-1",
                        { "expanded": showMenuItemDropdown }
                    );
                    return (
                        <li key={`mobile-menu-item-${index}`}>
                            <a href={url} className={level1ItemClassName}>
                                <span>{title}</span>
                            </a>
                            <button onClick={() => toggleMenuItemDropdown(title)}>
                                {showMenuItemDropdown && <MinusIcon className='minus-icon'/>}
                                {!showMenuItemDropdown && <PlusIcon />}
                            </button>
                            {showMenuItemDropdown &&
                                <div className='mobile-menu-item-dropdown'>
                                    <ul>
                                        {childMenus.map((child, idx) => {
                                            const childTitle = child?.title ?? "";
                                            const childUrl = child?.url ?? "";
                                            return (
                                                <li key={`child-menu-item-${idx}`}>
                                                    <a href={childUrl}>
                                                        {childTitle}
                                                    </a>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            }
                        </li>
                    );
                })}
                {staticLinks.map((link, i) => {
                    const linkTitle = link?.title ?? "";
                    const linkUrl = link?.url ?? "";
                    return (
                        <li key={`mobile-nav-link-${i}`}>
                            <a href={linkUrl} className='mobile-menu-item-level-1'>
                                {linkTitle}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export { MobileDropdownMenu };
